import { render, staticRenderFns } from "./WorkflowReportConfig.vue?vue&type=template&id=4fa9074a&"
import script from "./WorkflowReportConfig.vue?vue&type=script&lang=js&"
export * from "./WorkflowReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowReportConfig.vue?vue&type=style&index=0&id=4fa9074a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports